<template>
  <div class="preview-colors">
    <div class="preview-colors__header mockup__input">
      <label
        :class="available ? 'mockup__btn' : 'mockup__btn mockup__btn--disabled'"
        :for="available ? `previewColors${timestamp}` : ''"
        >Upload Colors</label
      >
      <input
        multiple
        type="file"
        v-show="false"
        :id="`previewColors${timestamp}`"
        ref="previewColors"
        @change="setPreviewColors"
        accept=".png, .jpg, .jpeg"
      />
    </div>

    <div class="preview-colors__loading" v-show="loading">
      wait upload finish...
    </div>

    <div class="preview-colors__content-list">
      <draggable
        group="colors"
        v-model="localColors"
        @end="$emit('setColors', localColors)"
        class="preview-colors__list"
      >
        <preview-color
          v-for="(previewColor, i) in previewColors"
          :key="i"
          :current="previewColor"
          :colors="colors"
          :timestamp="timestamp"
          @addColor="(r) => $emit('addColor', r)"
        />
      </draggable>
    </div>
  </div>
</template>

<script>
import { uploadPreviewAsset } from "@/api/catalog-api/mockup-preview-asset-api/mockupPreviewAsset.api.js";

import PreviewColor from "./preview-color/PreviewColor.vue";
import draggable from "vuedraggable";

export default {
  components: { draggable, PreviewColor },
  props: {
    current: Object,
    colors: Array,
    timestamp: Number,
    imageWidth: Number,
    imageHeight: Number,
  },
  data() {
    return { localColors: [], loading: false };
  },
  computed: {
    available() {
      return !!this.imageWidth && !!this.imageHeight;
    },
    /* eslint-disable */
    previewColors() {
      return !!this.current.previewColors
        ? this.current.previewColors.sort((a, b) => (a.order - b.order))
        : [];
    },
    /* eslint-enable */
  },
  watch: {
    colors() {
      this.localColors = this.colors;
    },
  },
  methods: {
    validate(files) {
      const _URL = window.URL || window.webkitURL;
      const promises = [];
      const response = [];
      files.forEach((file) =>
        promises.push(
          new Promise((r) => {
            const i = new Image();
            i.onload = () => {
              if (this.imageWidth === i.width && this.imageHeight === i.height)
                response.push(file);
              r();
            };
            i.src = _URL.createObjectURL(file);
          })
        )
      );
      return Promise.all(promises).then(() => response);
    },
    setPreviewColors() {
      const files = this.$refs.previewColors.files;
      if (!!files && !!files.length) {
        this.loading = true;
        this.validate(files).then((res) => {
          const promises = [];
          res.forEach((file) =>
            promises.push(
              uploadPreviewAsset({
                file: file,
                hex: null,
                jsClass: "PreviewColorModel",
                order: 0,
              }).then((r) => this.current.addPreviewColor(r))
            )
          );

          Promise.all(promises)
            .catch(() => alert("Error"))
            .finally(() => (this.loading = false));
        });
      }
    },
  },
  mounted() {
    this.current.previewColors.forEach((p) => this.$emit("addColor", p.hex));
    setTimeout(() => (this.localColors = this.colors), 100);
  },
};
</script>

<style lang="scss" scoped>
.preview-colors {
  flex: 1;
  position: relative;

  &__content-list {
    overflow: auto;
  }

  &__list {
    display: grid;
    grid-auto-flow: column;
    // grid-template-columns: repeat(auto-fill, minmax(200px, auto));
    gap: 6px;
    width: 200px;
  }

  &__loading {
    text-align: center;
    font-size: 16px;
    padding: 6px;
    border-radius: 5px;
    margin-bottom: 6px;
    color: #ffc107;
    border: 1px solid #ff9800;
  }
}
</style>
